import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./features/auth/Login";
import DashLayout from "./components/DashLayout";
import Welcome from "./features/auth/Welcome";
import Prefetch from "./features/auth/Prefetch";
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from "./features/auth/RequireAuth";
import { ROLES } from "./config/roles";
import useTitle from "./hooks/useTitle";
import Datasource from "./features/dataSource/DataSource";
import MyAccount from "./features/myAccount/MyAccount";
import Library from "./features/Library";
import Admin from "./features/Admin/Admin.js";
import Favorite from "./features/Favorite";
import Recent from "./features/Recent";
import Shared from "./features/Shared";
import Trending from "./features/Trending";
import ConfigdataSource from "./features/dataSource/sql/ConfigdataSource";
import ForgotPage from "./features/auth/ForgotPage.js";
import SetPasswordPage from "./features/auth/SetPasswordPage.js";
import Workbook from "./features/reduxworkbook/Workbook.js";
import { NavigationProvider } from "./NavigationContext.js";
import EditDataSources from "./features/EditDataSources/EditDataSources.js";
import { useNavigate } from "react-router-dom";
import ViewWorkbook from "./features/Viewworkbook/ViewWorkbook.js";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentToken, logOut } from "./features/auth/authSlice";
import AddUser from "./features/Admin/AddUser.js";
import EditUser from "./features/Admin/EditUser.js";
import EditDSPage from "./features/EditDataSources/EditDSPage.js";
import DemoLoginPage from "./features/DemoLoginPage.js";
import Meeting from "./features/metting/Meeting.js";
import JoinTable from "./features/JoinTables/JoinTable.js";
import NotFoundPage from "./NotFoundPage.js";
import Group from "./features/Group/Group.js";
import CreateGroup from "./features/Group/CreateGroup.js";
import UpdateGroup from "./features/Group/UpdateGroup.js";
import AccessControl from "./features/EditDataSources/AccessControl.js";
import Accessworkbookpage from "./features/EditDataSources/Accessworkbookpage.js";
import RequireEmbedAuth from "./features/auth/RequireEmbedAuth.js";
import EmbedAuth from "./features/Embedd/EmbeddAuth.js";
import { useMyContext } from "./MyContext.js";
import toast, { Toaster } from "react-hot-toast";
import RowLevelAccess from "./features/EditDataSources/RowLevelAccess.js";

function App() {
  useTitle("Vizta");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(selectCurrentToken);
  let { toast: toastData } = useMyContext();
  // toast = { message: "Data is reached of limit 500 please apply filters for better understanding", status: "error" };
  const showToast = (message, type = "error", time = 10000) => {
    const toastConfig = {
      duration: time, // time in ms
      position: "top-center",
    };
    switch (type) {
      case "success":
        toast.success(message, toastConfig);
        break;
      case "error":
        toast.error(message, toastConfig);
        break;
      case "loading":
        toast.loading(message, toastConfig);
        break;
      default:
        toast.error(message, toastConfig);
        break;
    }
  };
  useEffect(() => {
    // console.log("toast", toastData);
    if (toastData) {
      if (toastData.message && toastData.status) {
        showToast(toastData.message, toastData.status);
      }
    }
  }, [toastData]);

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000; // Current time in seconds
      return payload.exp < currentTime;
    } catch (e) {
      console.error("Failed to parse token", e);
      return true; // Treat the token as expired if there's an error
    }
  };

  useEffect(() => {
    const checkToken = () => {
      if (isTokenExpired(token)) {
        dispatch(logOut()); // Clear token in Redux state
        localStorage.removeItem("loggedInUser"); // Remove token from local storage
        // navigate("/login"); // Navigate to login page
      }
    };

    // Check token validity when the component mounts or token changesjs
    checkToken();

    // Optional: Set an interval to check the token every minute
    const interval = setInterval(checkToken, 60000); // Check every 60 seconds
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [token, dispatch, navigate]);

  return (
    <NavigationProvider>
      <Toaster />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* public routes */}
          <Route index element={<Login />} />
          <Route path="login" element={<Login />} />
          {/* <Route path="logindemopage" element={<DemoLoginPage />} /> */}
          <Route path="/forget" element={<ForgotPage />} />
          <Route path="/setPassword" element={<SetPasswordPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="embed" element={<EmbedAuth />} />

          {/* Protected Routes */}
          <Route element={<PersistLogin />}>
            <Route element={<Prefetch />}>
              {/* Common Routes */}
              <Route
                element={
                  <RequireAuth allowedRoles={[...Object.values(ROLES)]} />
                }
              >
                <Route path="/home/dash" element={<DashLayout />}>
                  <Route index element={<Welcome />} />
                  <Route path="library/:folderId" element={<Library />} />
                  <Route path="favorite">
                    <Route index element={<Favorite />} />
                  </Route>
                  <Route path="recent">
                    <Route index element={<Recent />} />
                  </Route>
                  <Route path="shared">
                    <Route index element={<Shared />} />
                  </Route>
                  <Route path="trending">
                    <Route index element={<Trending />} />
                  </Route>
                  <Route path="myaccount">
                    <Route index element={<MyAccount />} />
                  </Route>
                  {/* protected Routes inside DashLayot for creator and admin */}
                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[ROLES.Admin, ROLES.Creator]}
                      />
                    }
                  >
                    <Route
                      path="editdatasource"
                      element={<EditDataSources />}
                    />
                    <Route path="edit" element={<EditDSPage />} />
                    <Route path="access" element={<AccessControl />} />
                    <Route path="rowlevelaccess" element={<RowLevelAccess />} />
                    <Route
                      path="accessworkbook"
                      element={<Accessworkbookpage />}
                    />

                    {/* <Route path="editdatasource" element={<EditDataSources />} /> */}
                  </Route>
                  {/* protected Routes inside DashLayot for admin */}
                  <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                    <Route path="admin" element={<Admin />} />
                    <Route path="group" element={<Group />} />
                    <Route path="Creategroup" element={<CreateGroup />} />
                    <Route path="updategroup" element={<UpdateGroup />} />

                    <Route path="addNewUser" element={<AddUser />} />
                    <Route path="editUser" element={<EditUser />} />
                  </Route>
                </Route>
              </Route>

              {/* Routes for explorer */}
              <Route
                element={
                  <RequireAuth
                    allowedRoles={[ROLES.Explorer, ROLES.Creator, ROLES.Admin]}
                  />
                }
              >
                <Route path="/datasource" element={<Datasource />} />
                <Route path="/jointables" element={<JoinTable />} />
                <Route element={<Prefetch />}>
                  <Route path="/workbook" element={<Workbook />} />
                </Route>
              </Route>

              {/* Routes for creator */}
              <Route
                element={
                  <RequireAuth allowedRoles={[ROLES.Creator, ROLES.Admin]} />
                }
              >
                <Route path="dataconfigure" element={<ConfigdataSource />} />
              </Route>
            </Route>
            {/* this viewWorkbook route is outside prefetch because setWorkBookData is working in prefetch
                which sets the original data of workbook*/}
            <Route
              element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}
            >
              <Route element={<RequireEmbedAuth />}>
                <Route path="dashboard" element={<ViewWorkbook />} />
              </Route>
            </Route>
            {/* End Protected Routes */}
          </Route>
        </Route>
      </Routes>
    </NavigationProvider>
  );
}
export default App;
